import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { DockProvider, Dock } from './components/Dock';
import { MainContent } from './components/Layout';
import { HomePage } from './pages/HomePage';

/**
 * Root application component
 * Sets up routing, dock provider, and main layout
 */
export function App(): JSX.Element {
  return (
    <BrowserRouter>
      <DockProvider>
        <MainContent hasNotch={false}>
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
        </MainContent>
        <Dock />
      </DockProvider>
    </BrowserRouter>
  );
}
